<template>
    <ConfirmDialog />
    <Toast />
    <div class="grid nested-grid">
        <div class="col-12">
            <div class="card fluid cardheader">
                <div class="col-12">
                    <h5 class="stationsHeader">{{ pageTitle }}</h5>
                </div>
            </div>

            <DataTable :value="companies" class="p-datatable-sm" removableSort showGridlines dataKey="Id"
                v-model:filters="filters1" :loading="loading1" responsiveLayout="scroll" :rowHover="true"
                :globalFilterFields="['Name','VATId','Address','Zip','City']">
                <template #header>
                    <div class="flex justify-content-between">
                        <Button :label="translated('receivingSupportCompanyNew')" :disabled="!isMAdmin" icon="pi pi-plus" class="p-button" @click="openModalAddCompany()" />
                        <span class="p-input-icon-right">
                            <i class="pi pi-search" />
                            <InputText v-model="filters1['global'].value" :placeholder="translated('keywordsearch')" />
                        </span>
                    </div>
                </template>
                <template #empty>
                    No receiving support companies found.
                </template>
                <template #loading>
                    Loading receiving support companies. Please wait.
                </template>

                <Column :header="translated('companyname')" field="Name" :sortable="true"></Column>
                <Column :header="translated('taxid')" field="VATId" :sortable="true"></Column>
                <Column :header="translated('street')" field="Address"></Column>
                <Column :header="translated('zip')" field="Zip"></Column>
                <Column :header="translated('city')" field="City"></Column>
                <Column v-if="isFinancedFiltered" :header="translated('receivingSupportCompanyStatus')">
                    <template #body="slotProps">
                        {{ isLinked(slotProps.data) ? translated('linkedStatus') : translated('notLinkedStatus') }}
                    </template>
                </Column>
                <Column :exportable="false" :style="isFinancedFiltered ? {width:'220px'} : {width:'130px'}" bodyStyle="text-align: right">
                    <template #body="slotProps">
                        <div class="action-buttons">
                            <Button v-if="isFinancedFiltered"
                                :disabled="!isMAdmin"
                                :label="isLinked(slotProps.data) ? translated('unlinkbutton') : translated('linkbutton')"
                                :icon="isLinked(slotProps.data) ? 'pi pi-times' : 'pi pi-link'"
                                class="p-button-sm"
                                :class="isLinked(slotProps.data) ? 'p-button-warning' : 'p-button-secondary'"
                                @click="toggleLink(slotProps.data)" />
                            <Button v-if="isFinancedFiltered"
                                :disabled="!isLinked(slotProps.data)"
                                icon="pi pi-file-edit"
                                class="p-button-rounded p-button-secondary"
                                @click="openReceivingAgreements(slotProps.data)" />
                            <router-link v-if="!isFinancedFiltered" :to="{ name: 'ReceivingSupportCompanyFinancedOverview', params: { companyId: slotProps.data.Id } }">
                                <Button icon="pi pi-sitemap" class="p-button-rounded p-button-secondary" />
                            </router-link>
                            <Button :disabled="!isMAdmin" icon="pi pi-pencil" class="p-button-rounded p-button-success editbutton" @click="openModalEditCompany(slotProps.data)" />
                            <Button :disabled="!isMAdmin" icon="pi pi-trash" class="p-button-rounded p-button-warning deletebutton" @click="deleteCompany(slotProps.data)" />
                        </div>
                    </template>
                </Column>
            </DataTable>
        </div>
    </div>

    <Dialog v-model:visible="displayModalCompany" :style="{width: '32vw'}" :modal="true" class="globalDialog">
        <template #header>
            <span class="p-dialog-title">{{ popupTitle }}</span>
        </template>
        <div class="card fluid">
            <div class="field grid">
                <label class="col-12 md:col-4 mb-md-0">{{ translated('companyname') }}</label>
                <div class="col-12 md:col-8">
                    <InputText type="text" v-model="tmpName" />
                </div>
            </div>
            <div class="field grid">
                <label class="col-12 md:col-4 mb-md-0">{{ translated('taxid') }}</label>
                <div class="col-12 md:col-8">
                    <InputText type="text" v-model="tmpVATId" />
                </div>
            </div>
            <div class="field grid">
                <label class="col-12 md:col-4 mb-md-0">{{ translated('street') }}</label>
                <div class="col-12 md:col-8">
                    <InputText type="text" v-model="tmpAddress" />
                </div>
            </div>
            <div class="field grid">
                <label class="col-12 md:col-4 mb-md-0">{{ translated('zip') }}</label>
                <div class="col-12 md:col-8">
                    <InputText type="text" v-model="tmpZip" />
                </div>
            </div>
            <div class="field grid">
                <label class="col-12 md:col-4 mb-md-0">{{ translated('city') }}</label>
                <div class="col-12 md:col-8">
                    <InputText type="text" v-model="tmpCity" />
                </div>
            </div>
        </div>
        <template #footer>
            <Button :label="translated('canclebutton')" icon="pi pi-times" @click="closeModalCompany" class="p-button-text"/>
            <Button :disabled="!isMAdmin" :label="translated('savebutton')" icon="pi pi-check" @click="saveCompany" autofocus />
        </template>
    </Dialog>
</template>

<script>
import { FilterMatchMode } from 'primevue/api';
import createHttp from "@/services/http";
import { computed } from "vue";
import store from "@/store";

export default {
    props: ['financedId'],
    data() {
        return {
            translated: computed(() => store.getters.getTranslate),
            companies: [],
            financedRecords: [],
            financedLookup: {},
            loading1: true,
            filters1: null,
            displayModalCompany: false,
            popupTitle: '',
            isNewCompany: false,
            tmpId: '',
            tmpName: '',
            tmpVATId: '',
            tmpAddress: '',
            tmpZip: '',
            tmpCity: ''
        };
    },
    created() {
        this.initFilters1();
    },
    async mounted() {
        await this.loadData();
    },
    computed: {
        isMAdmin() {
            return this.$store.getters.isInRole("MAdmin");
        },
        isFinancedFiltered() {
            return !!this.financedId;
        },
        receivingSupportCompanyApiBaseUrl() {
            return process.env.VUE_APP_API_FOLDER;
        },
        pageTitle() {
            if (!this.isFinancedFiltered) {
                return this.translated('receivingSupportCompaniesTitlePlural');
            }

            const financed = this.financedLookup[this.financedId];
            return financed
                ? `${this.translated('receivingSupportCompaniesForFinanced')} ${financed.Name}`
                : this.translated('receivingSupportCompaniesTitle');
        }
    },
    methods: {
        getEmptyGuid() {
            return '00000000-0000-0000-0000-000000000000';
        },
        initFilters1() {
            this.filters1 = {
                global: { value: null, matchMode: FilterMatchMode.CONTAINS }
            };
        },
        async loadData() {
            this.loading1 = true;
            const http = createHttp(true);

            const [companiesResult, financedCompanieResult] = await Promise.all([
                http.get(this.receivingSupportCompanyApiBaseUrl + "/GetReceivingSupportCompanies"),
                http.get(this.receivingSupportCompanyApiBaseUrl + "/GetFinancedCompanieRecords")
            ]);

            this.companies = companiesResult.status === 200 ? companiesResult.data : [];
            this.financedRecords = financedCompanieResult.status === 200 ? financedCompanieResult.data : [];

            if (this.isFinancedFiltered) {
                const financedResult = await http.get(process.env.VUE_APP_API_FOLDER + "/GetFinanceRecords");
                if (financedResult.status === 200) {
                    this.financedLookup = financedResult.data.reduce((acc, item) => {
                        acc[item.Id] = item;
                        return acc;
                    }, {});
                }
            }

            this.loading1 = false;
        },
        isLinked(company) {
            if (!this.isFinancedFiltered) {
                return false;
            }

            return this.financedRecords.some(x => x.FinancedId === this.financedId && x.ReceivingSupportCompanyId === company.Id);
        },
        getFinancedCompanieRecord(company) {
            return this.financedRecords.find(x => x.FinancedId === this.financedId && x.ReceivingSupportCompanyId === company.Id) || null;
        },
        openReceivingAgreements(company) {
            if (!this.isLinked(company)) {
                return;
            }

            this.$router.push({
                name: 'ReceivingAgreements',
                params: {
                    financedId: this.financedId,
                    companyId: company.Id
                }
            });
        },
        openModalAddCompany() {
            this.popupTitle = this.translated('receivingSupportCompanyNew');
            this.isNewCompany = true;
            this.tmpId = crypto.randomUUID();
            this.tmpName = '';
            this.tmpVATId = '';
            this.tmpAddress = '';
            this.tmpZip = '';
            this.tmpCity = '';
            this.displayModalCompany = true;
        },
        openModalEditCompany(company) {
            this.popupTitle = this.translated('receivingSupportCompanyEdit');
            this.isNewCompany = false;
            this.tmpId = company.Id;
            this.tmpName = company.Name;
            this.tmpVATId = company.VATId;
            this.tmpAddress = company.Address;
            this.tmpZip = company.Zip;
            this.tmpCity = company.City;
            this.displayModalCompany = true;
        },
        closeModalCompany() {
            this.displayModalCompany = false;
        },
        async saveCompany() {
            const http = createHttp(true);
            const company = {
                Id: this.tmpId,
                Name: this.tmpName,
                VATId: this.tmpVATId,
                Address: this.tmpAddress,
                Zip: this.tmpZip,
                City: this.tmpCity
            };

            try {
                const response = await http.post(this.receivingSupportCompanyApiBaseUrl + "/SaveReceivingSupportCompanies", [company]);
                if (response.status === 200) {
                    if (this.isFinancedFiltered && this.isNewCompany) {
                        await this.linkCompany(company, false);
                    }

                    await this.loadData();
                    this.$toast.add({ severity:'success', summary:'Confirmed', detail:'Record saved!', life: 3000 });
                    this.displayModalCompany = false;
                }
            } catch (error) {
                const detail = error?.response?.data?.message || 'ERROR';
                this.$toast.add({ severity:'error', summary:'Error', detail, life: 5000 });
            }
        },
        deleteCompany(company) {
            this.$confirm.require({
                message: this.translated('receivingSupportCompanyDeleteQuestion'),
                header: this.translated('deletecompanytitle'),
                icon: 'pi pi-exclamation-triangle',
                acceptClass: 'p-button-danger',
                accept: async () => {
                    const http = createHttp(true);
                    try {
                        const response = await http.delete(this.receivingSupportCompanyApiBaseUrl + "/DeleteReceivingSupportCompany?id=" + company.Id);
                        if (response.status === 200) {
                            await this.loadData();
                            this.$toast.add({ severity:'success', summary:'Confirmed', detail:'Record deleted', life: 3000 });
                        }
                    } catch (error) {
                        const detail = error?.response?.data?.message || 'ERROR';
                        this.$toast.add({ severity:'error', summary:'Error', detail, life: 5000 });
                    }
                }
            });
        },
        async toggleLink(company) {
            if (this.isLinked(company)) {
                await this.unlinkCompany(company);
            } else {
                await this.linkCompany(company, true);
            }
        },
        async linkCompany(company, showToast) {
            const http = createHttp(true);
            const financedCompanie = {
                Id: crypto.randomUUID(),
                FinancedId: this.financedId,
                ReceivingSupportCompanyId: company.Id
            };

            try {
                const response = await http.post(this.receivingSupportCompanyApiBaseUrl + "/SaveFinancedCompanieRecords", [financedCompanie]);
                if (response.status === 200) {
                    await this.loadData();
                    if (showToast) {
                        this.$toast.add({ severity:'success', summary:'Confirmed', detail:this.translated('linkbutton'), life: 3000 });
                    }
                }
            } catch (error) {
                const detail = error?.response?.data?.message || 'ERROR';
                this.$toast.add({ severity:'error', summary:'Error', detail, life: 5000 });
            }
        },
        async unlinkCompany(company) {
            const record = this.getFinancedCompanieRecord(company);
            if (!record) {
                return;
            }

            const http = createHttp(true);
            try {
                const response = await http.delete(this.receivingSupportCompanyApiBaseUrl + "/DeleteFinancedCompanieRecord?id=" + record.Id);
                if (response.status === 200) {
                    await this.loadData();
                    this.$toast.add({ severity:'success', summary:'Confirmed', detail:this.translated('unlinkbutton'), life: 3000 });
                }
            } catch (error) {
                const detail = error?.response?.data?.message || 'ERROR';
                this.$toast.add({ severity:'error', summary:'Error', detail, life: 5000 });
            }
        }
    }
}
</script>

<style scoped>
.action-buttons {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 0.5rem;
}

.agreements-section h6 {
    margin: 0;
}
</style>
